import React, { useState } from 'react';
import { Chessboard } from 'react-chessboard';
import { Chess } from 'chess.js';

const Game = () => {
  const [game, setGame] = useState(new Chess());

  const onDrop = (sourceSquare, targetSquare) => {
    // Make a move in the chess.js game instance
    const move = game.move({ from: sourceSquare, to: targetSquare });

    // Illegal move
    if (move === null) return false;

    // Update the game state
    setGame(new Chess(game.fen()));
    return true;
  };

  return (
    <div className="app-container">
      <Chessboard
        position={game.fen()}
        onPieceDrop={onDrop}
        boardWidth={600}
        customDarkSquareStyle={{
          background: "linear-gradient(to left, #3066BE, #4A7DD9)",
        }}
        customLightSquareStyle={{
          background: "linear-gradient(to left, #fffff0, #f5e4c3)",
        }}
      />
    </div>
  );
};

export default Game;


